import useThreeElement from "./useThreeElement";
import animate from "./animate";
import { easeInOutCubic } from "@shared/lib/animation/easing";
import { Group, Vector3 } from "three";
import { inject, ref } from "vue";

export const panGroupInjectionKey = Symbol("panGroup");

export default function usePan (group?: Group) {
  const {
    canvas,
  } = useThreeElement();
  const panGroup = inject<Group>(panGroupInjectionKey, group || new Group());
  const panPosition = ref(panGroup.position);

  function animatePan ({
    position,
    duration,
  }: {
    position: Vector3,
    duration: number,
  }): Promise<void> {
    const startPosition = panGroup.position.clone();
    const targetPosition = position;

    return animate((t) => {
      panGroup.position.lerpVectors(startPosition, targetPosition, t);
      canvas.requestRender();
    }, {
      duration,
      easing: easeInOutCubic,
    });
  }

  return {
    panPosition,
    animatePan,
  };
}
